import PubSub from 'pubsub-js';
import SlaveShownData from '../types/SlaveShownData';

export const SLAVE_SHOWN_EVENT_ID = Symbol('7T:Slave.Shown');

export const slaveShownEventPubSub:
PubSubJS.Base<SlaveShownData, typeof SLAVE_SHOWN_EVENT_ID> = PubSub;
